import { App } from 'antd'

let message
let notification
let modal

const FeedbackProvider = ({ children }) => {
  const staticFunction = App.useApp()
  message = staticFunction.message
  notification = staticFunction.notification
  modal = staticFunction.modal

  return children
}

export { message, modal, notification }
export default FeedbackProvider
